// extracted by mini-css-extract-plugin
export default {"title":"PasswordRecovery_title__FF++0","back":"PasswordRecovery_back__7Xqiz","text":"PasswordRecovery_text__6Y01j"};